<template>
  <div
    class="dui-context-menu"
    :class="{ 'center': side === 'center',
              'left': side === 'left',
              'open': vm.isOpen }"
  >
    <div
      class="trigger"
      @click.stop.prevent="toggleOpen"
    >
      <slot name="trigger" />
    </div>

    <div
      class="options"
      :style="{ width: optionsWidth + 'px' }"
    >
      <span class="tip" />
      <slot name="options" />
    </div>
  </div>
</template>

<script>
import contextMenuMixin from '@dui/mixins/context-menu';

export default {
  mixins: [
    contextMenuMixin,
  ],
  props: {
    optionsWidth: {
      type: Number,
      default: null,
    },
    side: {
      type: String,
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@dui-styles/base";

.dui-context-menu {
  @include makeContextMenu();
}
</style>
